/**
 * Planer i RCP — urlop wypoczynkowy (`pln.vacation.*`, NX-414): saldo przy wniosku i decyzji, wymiar w kartotece (kadry),
 * ustawienia organizacji i wydruk wniosku (PDF).
 */
import type { Shape } from './planner-worktime-pl';

export const plnVacationPl = {
  balance: {
    title: 'Urlop {year}',
    entitlement: 'Wymiar',
    carried: 'Zaległy',
    used: 'Wykorzystany',
    planned: 'Zaplanowany',
    remaining: 'Pozostało',
    days: '{value} dni',
    defaultHint: 'Wymiar domyślny organizacji — kadry mogą go zmienić w widoku Urlopy.',
    thisRequest: 'Ten wniosek — dni robocze: {n}',
    after: 'Po tym wniosku zostanie: {value} dni',
    over: 'Wniosek przekracza saldo urlopu o {value} dni.',
    overBlock: 'Wniosek przekracza saldo urlopu — organizacja nie przyjmuje takich wniosków.',
  },
  workingDays: 'dni robocze: {n}',
  exceeds: 'Ponad saldo urlopu',
  pdf: 'PDF',
  pdfTitle: 'Pobierz wydruk wniosku z decyzją (PDF)',
  pdfFailed: 'Nie udało się pobrać wydruku wniosku',
  settings: {
    title: 'Urlop wypoczynkowy',
    description: 'Domyślny roczny wymiar dla osób bez wpisu w kartotece i to, co robi wniosek urlopowy ponad saldo.',
    defaultDays: 'Domyślny wymiar (dni)',
    overLimit: 'Wniosek ponad saldo',
    overLimitOpt: { WARN: 'Ostrzeżenie — wniosek przechodzi', BLOCK: 'Odmowa — wniosku nie da się złożyć' },
    saved: 'Zapisano ustawienia urlopu',
  },
};

export const plnVacationEn: Shape<typeof plnVacationPl> = {
  balance: {
    title: 'Leave {year}',
    entitlement: 'Entitlement',
    carried: 'Carried over',
    used: 'Used',
    planned: 'Planned',
    remaining: 'Remaining',
    days: '{value} days',
    defaultHint: 'Organisation default — HR can change it in the Leave view.',
    thisRequest: 'This request — working days: {n}',
    after: 'Left after this request: {value} days',
    over: 'The request exceeds the leave balance by {value} days.',
    overBlock: 'The request exceeds the leave balance — the organisation does not accept such requests.',
  },
  workingDays: 'working days: {n}',
  exceeds: 'Over the leave balance',
  pdf: 'PDF',
  pdfTitle: 'Download the request printout with the decision (PDF)',
  pdfFailed: 'Could not download the request printout',
  settings: {
    title: 'Annual leave',
    description: 'Default yearly entitlement for people without an entry and what a leave request over the balance does.',
    defaultDays: 'Default entitlement (days)',
    overLimit: 'Request over the balance',
    overLimitOpt: { WARN: 'Warning — the request goes through', BLOCK: 'Refusal — the request cannot be submitted' },
    saved: 'Leave settings saved',
  },
};
